import {ITranslatedField} from "@/helpers/TranslationHelper";
import {IServiceTag} from "@/model/Service/serviceInterfaces";

export enum EServiceProviderType {
  supermarket = 'supermarket',
  open_order = 'open_order',
  offline = 'offline',
  services = 'services',
  infocard = 'infocard',
  infocard_sending = 'infocard_sending',
  home_delivery = 'home_delivery',
  drop_only = 'drop_only',
  amazon_return = 'amazon_return',
  smart_drop = 'smart_drop',
  smart_storage = 'smart_storage',
  professional_services = 'professional_services',
  webview = 'webview',
}

export enum EServiceProvidersCategories {
  CATEGORY_DELIVERY = 10,  // V3_CATEGORY_MY_BUILDING
  CATEGORY_FOOD = 20, // V3_CATEGORY_FOOD
  CATEGORY_DAILYFOOD = 30,
  CATEGORY_SHOP = 40, // V3_CATEGORY_SHOPS_GIFTS
  CATEGORY_CLICKNCOLLECT = 50,
  CATEGORY_SERVICES = 60, // V3_CATEGORY_SERVICES_FOR_ME
  CATEGORY_ONECLICK = 70,
  CATEGORY_BUILDINGSERVICES = 80, //


  // "V3" categories
  V3_CATEGORY_MY_BUILDING = 210,
  V3_CATEGORY_MOBILITY = 220,
  V3_CATEGORY_KIDS = 230, // KIDS
  V3_CATEGORY_PETS = 240,
  V3_CATEGORY_FOOD = 250,
  V3_CATEGORY_CIRCULAR_ECONOMY = 260,
  V3_CATEGORY_ASSISTANCE = 270,
  V3_CATEGORY_PARCEL_SERVICES = 280,
  V3_CATEGORY_LIFESTYLE = 290,
  V3_CATEGORY_CORP = 300,

  CATEGORY_ALL = -1,
}

export enum E_SERVICE_PROVIDER_TAG_TYPES {
  NO_TAG = 'NO_TAG',
  DISCOUNT_PERCENTAGE = 'DISCOUNT_PERCENTAGE',
  LAST_UNITS = 'LAST_UNITS',
  LIMITED_TIME = 'LIMITED_TIME',
  GOOD_REVIEWS = 'GOOD_REVIEWS',
  FREE_SHIPPING = 'FREE_SHIPPING',
  NEW = 'NEW',
}

export interface ISPCategory {
  id: number;
  sp_position: number;
}

/** Query parameter name the provider expects for each identifier we append to its link */
export interface ILinkTrackingParams {
  user?: string;
  community?: string;
}

export interface IServiceProvider {

  id: number;
  active: string;
  is_demo: boolean;
  address_county: string;
  address_country_id: string;
  address_line_1: string;
  address_line_2: string;
  address_postcode: string;
  address_town_city: string;
  autoconfirm: string;
  categories: ISPCategory[];
  channel_ids: number[];
  delivery_address: string;
  display_locker: boolean;
  email: string;
  extensions: string[];
  has_item_tracking: string;
  invoicing_address: string;
  link: ITranslatedField;
  phone_for_queries: string;
  name: string;
  payment_provider: string;
  phone_number: string;
  phone_number_mobile: string;
  send_communications: boolean;
  status: string;
  tax_id_number: string;
  tax_percentage: string;
  type: EServiceProviderType;
  uploads_enabled: boolean;
  use_only_restricted_cells: boolean;
  website: string;
  color: string;
  qr_bizcocho: number;
  qr_locker: number;

  created_at: string;
  updated_at: string;
  deleted_at: string;

  about_us: ITranslatedField;
  order_instructions: ITranslatedField;
  primary_service_description: ITranslatedField;
  infocard_cta_text: ITranslatedField;
  instructions_1: ITranslatedField;
  instructions_2: ITranslatedField;
  instructions_3: ITranslatedField;


  logo_image_url: string;
  subscription_enabled: boolean;
  billing_anchor_day: number | null;
  billing_cutoff_day: number | null;
  billing_cycles_after_cutoff: number | null;
  subscription_proration_behavior: string | null;
  subscription_trial_days: number | null;
  subscription_trial_end_behavior: string | null;
  subscription_collection_method: string | null;
  subscription_days_until_due: number | null;
  subscription_payment_behavior: string | null;
  subscription_automatic_tax: boolean | null;
  stripe_discount_type: 'fixed' | 'percentage' | null;
  stripe_discount_value: number | null;

  service_price: number;
  calculation_unit: number;
  range_min: number;
  range_max: number;
  days_available: string;
  availability_lead_days?: number | null;
  availability_max_days?: number | null;
  availability_opening_hour?: number | null;
  availability_closing_hour?: number | null;
  availability_slot_minutes?: number | null;
  availability_defaults?: IProfessionalAvailabilityDefaults;
  service_includes: ITranslatedField;
  service_excludes: ITranslatedField;

  precheck_url?: string | null;
  purchase_url?: string | null;
  integration_data?: Record<string, unknown> | string | null;
  limited_to?: number[] | string[] | string | null;
  link_tracking_params?: ILinkTrackingParams | null;
  
  urgency_tag: ITranslatedField;
  urgency_tag_type: E_SERVICE_PROVIDER_TAG_TYPES;

  tags?: IServiceTag[];
  city_ids: number[];
  zipcodes: string[];
  verticals: number[];
  scope_country_id: number | null;
  webview_hides_app_interface: boolean;

}

export type ProfessionalAvailabilityField =
  'availability_lead_days'
  | 'availability_max_days'
  | 'availability_opening_hour'
  | 'availability_closing_hour'
  | 'availability_slot_minutes';

export type IProfessionalAvailabilityDefaults = Record<ProfessionalAvailabilityField, number>;
